import './header.scss';
import { Logo, LogoBlueBCP } from 'assets/images/svg';

const HeaderBCP: React.FC = () => {
    const redirectToSection = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <nav className="header" data-testid="header">
            <button onClick={redirectToSection} className='header__button-img'>
                <img
                    className="header__button__logo"
                    src={Logo}
                    alt={'logo'}
                />
            </button>
            <ul
                className="header__content header__content--block"
            >
                <li className="header__content__bcp">
                    <span className='header__content__bcp-label'>En alianza con</span>
                    <img className='header__content__bcp-logo' src={LogoBlueBCP} alt="" />
                </li>
            </ul>

        </nav>
    );
};

export default HeaderBCP;
